import React from 'react';

import { useIntl } from 'react-intl';

import * as location from 'utils/location';

import { ErrorEmptyStateImage } from './images';
import { EmptyStateWrapper, HeaderText, ImageWrapper, StyledActionButtonLink } from './styled';

export const ErrorState = () => {
  const { formatMessage } = useIntl();

  return (
    <EmptyStateWrapper>
      <ImageWrapper>
        <ErrorEmptyStateImage />
      </ImageWrapper>
      <HeaderText>{formatMessage({ id: 'recentItemsFailed' })}</HeaderText>
      <StyledActionButtonLink onClick={location.reload}>
        {formatMessage({ id: 'refresh' })}
      </StyledActionButtonLink>
    </EmptyStateWrapper>
  );
};
